import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import { Routes as configRouter } from '../../config/Routes';
import AuthenticationService from '../../services/AuthenticationService';
import { Loading } from '../../components/common';
import ErrorPage from '../../components/Simple/ErrorPage';
import ErrorPageNoBack from '../../components/Simple/ErrorPageNoBack';
import { validateTokenDest } from '../../utils/Constants';

class ValidateToken extends Component {
  state = {
    loading: true,
    validToken: false,
    validUrl: true,
    errorMessage: '',
    errorNetwork: false,
    errorStatus: 0,
  };

  componentDidMount() {
    const { route } = this.props;
    const {
      match: {
        params: { token, dest },
      },
    } = route;
    const validURL = dest === validateTokenDest.SIGN_IN || dest === validateTokenDest.RESET_PASS || dest === validateTokenDest.RESET_MFA;

    // Checking if url has the right format otherwise return error
    if (validURL) {
      this.validateToken(token, validURL);
    } else {
      this.setState({
        validUrl: false,
        loading: false,
      });
    }
  }

  validateToken = async (token, validURL) => {
    try {
      await AuthenticationService.validateToken(token);
      this.setState({
        validToken: validURL,
        loading: false,
      });
    } catch (error) {
      if (error.response) {
        this.setState({
          loading: false,
          errorNetwork: false,
          errorMessage: error.response.data.description,
          errorStatus: error.response.status,
        });
      } else {
        this.setState({
          errorNetwork: true,
          loading: false,
        });
      }
    }
  };

  getRedirectRoute = () => {
    const { route } = this.props;
    const {
      match: {
        params: { dest },
      },
    } = route;
    if (dest === validateTokenDest.SIGN_IN) return configRouter.SIGN_IN;
    if (dest === validateTokenDest.RESET_PASS) return configRouter.RESET_PASS;
    if (dest === validateTokenDest.RESET_MFA) return configRouter.AUTH_QR;
    return configRouter.HOME;
  };

  render() {
    const { t } = this.props;
    const { loading, validToken, validUrl, errorMessage, errorNetwork, errorStatus } = this.state;
    return (
      <Fragment>
        {loading && <Loading />}
        {!loading && validToken && validUrl && (
          <Redirect
            to={{
              pathname: this.getRedirectRoute(),
              state: { url: configRouter.VALIDATE_TOKEN },
            }}
          />
        )}
        {!loading && !errorNetwork && validUrl && <ErrorPage code={errorStatus} title={t('labelNetworkError')} subtitle={errorMessage} {...this.props} />}
        {!loading && errorNetwork && <ErrorPageNoBack title={t('errorTitleConnection')} text={t('errorMsgConnection')} />}
        {!loading && !validToken && !validUrl && <ErrorPage code={412} title={t('invalidUrlTitle')} subtitle={t('invalidUrlSubtitle')} {...this.props} />}
      </Fragment>
    );
  }
}

export default withNamespaces()(ValidateToken);
